import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { Typography } from 'seagull';
import { activityLogTextsPath, getBusinessContent, getIcon } from '~/components/ActivityLogItem/ActivityLogItem.utils';
import { useLocaleKeys } from '~/i18n';
import { timeModel } from '~/models';
import styles from './ActivityLogBusinessItem.module.scss';
export function ActivityLogBusinessItem(param) {
    let { entry, isFirst, isLast } = param;
    const { t: activityLogTexts } = useLocaleKeys(activityLogTextsPath);
    const content = getBusinessContent(activityLogTexts.business, entry);
    const testId = "activity-log-".concat(entry.id());
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.wrapper,
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: styles.date,
                children: /*#__PURE__*/ _jsx(Typography, {
                    children: timeModel.formatDateWithTime(entry.timestamp())
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.separator,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: cn(styles.line, {
                            [styles.transparent]: isFirst
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.dot
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: cn(styles.line, {
                            [styles.transparent]: isLast
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.card,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.icon,
                        children: getIcon(entry)
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        className: styles.content,
                        testId: testId,
                        children: content
                    })
                ]
            })
        ]
    });
}
